import { addHours, isBefore } from "date-fns";

import { useAuthentication } from "./useAuthentication";
import { useWebsocket } from "../../Actions/hooks";
import { pixRechargeRequest } from "../requests";
import { useActions } from "../provider";

export function usePix() {
  const { actionsState, setActionsState, setIsLoading, stepManager } =
    useActions();
  const { authToken } = useAuthentication({ setIsLoading });
  const websocket = useWebsocket();

  const { msisdn, plan } = actionsState;

  async function makePayment() {
    try {
      setIsLoading(true);
      setActionsState({
        paymentData: {
          pix: null,
        },
      });

      const response = await pixRechargeRequest({
        msisdn,
        value: plan.value,
        authToken,
      });

      const { code, pixKey, qrCode, txid, pixExpirationDate } = response.data;
      let getCurrentPixData = false;

      if (code === "P00") {
        getCurrentPixData = true;
        setActionsState({
          paymentData: {
            pix: parsePixObject(response.data, "PENDING"),
          },
        });
      }

      websocket.emit("pix-server-app", {
        txid,
        value: plan?.value.toString(),
        msisdn,
        rechargeMsisdn: msisdn,
        pixKey,
        qrcode: qrCode,
        pixExpirationDate,
      });

      websocket.listen("pix-client", (dataSocket) => {
        const parsedPixData = getCurrentPixData
          ? parsePixObject(response.data, "PENDING")
          : parsePixObject(dataSocket.lastTransactions.find(({ qrcode, value }) => !!qrcode && qrcode !== "" && value === plan?.value.toString()) || dataSocket.lastTransactions[0]);
        
        setActionsState({
          paymentData: {
            pix: parsedPixData,
          },
        });

        if (dataSocket.status === "P00") {
          websocket.emit("pix-server-app-response", {
            msisdn,
            txid,
            rechargeMsisdn: msisdn,
          });
        }
      });
    } catch (error) {
      console.log(error);
      stepManager.previous();
    } finally {
      setIsLoading(false);
    }
  }

  function parsePixObject(data, status) {
    const {
      pixKey,
      txid,
      pixExpirationDate,
      message,
    } = data;
    let qr_code_base64 = data?.qrCode;
    let recharge_id = data?.rechargeID || data?.id;

    if (!status) {
      status = isBefore(addHours(new Date(pixExpirationDate), 3), new Date())
        ? "EXPIRED"
        : message === "Pedding"
        ? "PENDING"
        : "PAID";
    }
    
    if(!qr_code_base64 || qr_code_base64 === '') qr_code_base64 = data.qrcode;

    return {
      recharge_id,
      txid,
      pix_code: pixKey,
      expiration_date: pixExpirationDate,
      qr_code_base64,
      status,
      message,
    };
  }

  return { makePayment };
}